var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.019,
    height: 41.019,
    viewBox: "0 0 41.019 41.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Activity_Details",
    "data-name": "Activity Details",
    transform: "translate(-6.2 -4.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M38.3,27.7a7.535,7.535,0,0,0-3.3.7V7.1a2.476,2.476,0,0,0-2.5-2.5H8.7A2.476,2.476,0,0,0,6.2,7.1v36a2.476,2.476,0,0,0,2.5,2.5H32.4a2.463,2.463,0,0,0,1.9-.9,8.967,8.967,0,0,0,7.9-16.1A10.573,10.573,0,0,0,38.3,27.7Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M32.4,44.6H8.7a1.538,1.538,0,0,1-1.5-1.5V7.1A1.538,1.538,0,0,1,8.7,5.6H32.4a1.538,1.538,0,0,1,1.5,1.5h0V28.8a14.309,14.309,0,0,0-1.5,1.1V8.5A1.538,1.538,0,0,0,30.9,7H10.2A1.473,1.473,0,0,0,8.7,8.5v31A1.538,1.538,0,0,0,10.2,41H30.4a9.207,9.207,0,0,0,3,3.2A1.159,1.159,0,0,1,32.4,44.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M31.4,30.9A9.083,9.083,0,0,0,29.9,40H10.2a.472.472,0,0,1-.5-.5V8.5a.472.472,0,0,1,.5-.5H30.9a.472.472,0,0,1,.5.5V30.9Z",
    fill: "#ffba50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M14.8,10.7a3.6,3.6,0,1,0,3.6,3.6h0A3.585,3.585,0,0,0,14.8,10.7Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M14.8,16.9a2.6,2.6,0,1,1,2.6-2.6h0A2.647,2.647,0,0,1,14.8,16.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 3.6,
    cy: 3.6,
    r: 3.6,
    transform: "translate(11.2 20.4)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 2.6,
    cy: 2.6,
    r: 2.6,
    transform: "translate(12.2 21.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M14.8,30.1a3.6,3.6,0,1,0,3.6,3.6h0A3.585,3.585,0,0,0,14.8,30.1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M14.8,36.2a2.6,2.6,0,1,1,2.6-2.6h0A2.582,2.582,0,0,1,14.8,36.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M21.9,42.1H19.2a.5.5,0,0,0,0,1h2.7a.5.5,0,0,0,0-1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M38.3,44.6a7.9,7.9,0,1,1,7.9-7.9h0A7.917,7.917,0,0,1,38.3,44.6Z",
    fill: "#7cc05b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M29.4,13.8H20.2a.5.5,0,0,0,0,1h9.2a.5.5,0,1,0,0-1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M15.8,13.1l-1.1,1.1-.4-.4a.495.495,0,0,0-.7.7h0l.8.8a.483.483,0,0,0,.7,0l1.5-1.5a.483.483,0,0,0,0-.7.6.6,0,0,0-.8,0Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M29.4,23.5H20.2a.5.5,0,0,0,0,1h9.2a.5.5,0,1,0,0-1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M15.8,22.8l-1.1,1.1-.4-.4a.495.495,0,0,0-.7.7h0l.8.8a.483.483,0,0,0,.7,0l1.5-1.5a.483.483,0,0,0,0-.7.6.6,0,0,0-.8,0Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M26.7,33.2H20.2a.5.5,0,0,0,0,1h6.5a.5.5,0,1,0,0-1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M15.8,32.5l-1.1,1.1-.4-.4a.495.495,0,0,0-.7.7h0l.8.8a.483.483,0,0,0,.7,0l1.5-1.5a.483.483,0,0,0,0-.7.6.6,0,0,0-.8,0Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M41.6,34.1l-3.8,3.8L36,36a.495.495,0,0,0-.7.7l2.2,2.2a.483.483,0,0,0,.7,0l4.1-4.1a.495.495,0,0,0-.7-.7Z",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityDetails);
export default __webpack_public_path__ + "static/media/Activity Details.8fdba81bbd16e747bba9a5b76b0561fc.svg";
export { ForwardRef as ReactComponent };